import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_API()

export default {

    wyslijDaneSprzedazyDoFK(data) {
        return axios({
            method: 'post',
            url: URL + 'fcm/kierowcy/serwis',
            data: JSON.stringify(data),
        });
    },

}


// WEBPACK FOOTER //
// ./src/modules/administracja/kierowcaSerwis/KierowcaSerwisService.js